import AnimatedLoadingRingSvg from './AnimatedLoadingRingSvg';

export default AnimatedLoadingRingSvg;
export { AnimatedLoadingRingSvg };
